// imports section
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  USERGROUP_API_01,
  REPORTS_API_01,
  REPORTS_API_02,
  USERGROUP_API_04,
} from "../../api/ApiModel";
import {
  CON_STATUS_ACTIVE,
  CON_STATUS_DELETED,
} from "../../utils/sys/Constants";
import {
  externalgetApi,
  externalpostApi,
} from "../../services/external/externalApis";
import { useStyles } from "../../assets/styles/Theme";
import Navbar from "../../components/common/Navbar";
import { useNavigate } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { useTheme } from "@mui/material/styles";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import {
  Grid,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Breadcrumbs,
  Link,
  AppBar,
  Checkbox,
  Typography,
} from "@mui/material";
import SnackbarMessage from "../../components/common/SnackbarMessage";
import { MSG_REPORT_SUCCESS } from "../../utils/sys/Messages";

function MapReports() {
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [userGroups, setUserGroups] = useState([]);
  const [reports, setReports] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState("");
  const [loading, setLoading] = useState(false);
  const [checkedReports, setCheckedReports] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [selectedModule, setSelectedModule] = useState("");
  const SYS_USER = useSelector((state) => state.user) || {};
  const [treeData, setTreeData] = useState([]);
  const [accessRights, setAccessRights] = useState([]);
  const { COMPCODE, USERNAME, RESTCODE, USERREFCODE } =
    SYS_USER.USER_PARAM || {};
  const [modules, setModules] = useState([]);
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  useEffect(() => {
    fetchUserGroups();
    // fetchMapReports();
  }, []);

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleCheckboxChange = (reportId) => {
    setCheckedReports(
      (prev) =>
        prev.includes(reportId)
          ? prev.filter((id) => id !== reportId) // Uncheck
          : [...prev, reportId] // Check
    );
  };

  useEffect(() => {
    if (selectedGroup) {
      fetchMapReports(selectedGroup);
    }
  }, [selectedGroup]);

  const handleGroupChange = (event) => {
    setSelectedGroup(event.target.value);
  };
  // Fetch user groups from API
  const fetchUserGroups = async () => {
    setLoading(true);
    try {
      const params = {
        COMPCODE: COMPCODE,
        STS: CON_STATUS_ACTIVE,
      };
      const response = await externalgetApi(USERGROUP_API_01, "GET", params);
      setUserGroups(response); // Assuming response is an array of user groups

      console.log("fetchUserGroups", response);
    } catch (error) {
      setError("Failed to fetch user groups.");
    } finally {
      setLoading(false);
    }
  };

  // Fetch map reports  from API
  const fetchMapReports = async (groupCode) => {
    try {
      setLoading(true);
      const params = {
        COMPCODE: COMPCODE,
        GROUPCODE: groupCode,
      };
      const response = await externalgetApi(REPORTS_API_01, "GET", params);

      // Filter reports based on MODULECODE
      const filteredReports = response.filter(
        (report) => report.MODULECODE === selectedModule
      );

      setReports(filteredReports); // Assuming response is an array of reports

      const checked = filteredReports
        .filter((report) => report.STS === CON_STATUS_ACTIVE)
        .map((report) => report.REPORTID);
      setCheckedReports(checked);

      console.log("fetchMapReports", filteredReports);
    } catch (error) {
      setError("Failed to fetch reports.");
    } finally {
      setLoading(false);
    }
  };

  const handleMapReport = async () => {
    try {
      const payload = {
        mapUsergroupReportsDt: checkedReports.length
          ? checkedReports.map((id) => ({ reportid: String(id) }))
          : [{ reportid: "" }],
        compcode: COMPCODE,
        groupcode: selectedGroup,
        enuser: USERNAME,
        sts: CON_STATUS_ACTIVE,
      };

      console.log("post payload", payload);

      const response = await externalpostApi(REPORTS_API_02, payload);
      console.log("post response", response);
      setSnackbarMessage(MSG_REPORT_SUCCESS);
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
    } catch (error) {
      setError("Failed to update access mapping.");
      console.error("API call error:", error);
    }
  };

  const handleModuleChange = (event) => {
    const moduleCode = event.target.value;
    setSelectedModule(moduleCode);
  };

  const fetchUserAccessForModules = async (groupCode) => {
    try {
      setLoading(true);
      const response = await externalgetApi(USERGROUP_API_04, "GET", {
        GROUPCODE: groupCode,
        COMPCODE: COMPCODE,
      });

      // Extract unique MODULECODE and MODULENAME
      const uniqueModules = response.reduce((acc, curr) => {
        if (!acc.some((item) => item.MODULECODE === curr.MODULECODE)) {
          acc.push({
            MODULECODE: curr.MODULECODE,
            MODULENAME: curr.MODULENAME,
          });
        }
        return acc;
      }, []);

      setModules(uniqueModules);
      console.log("Modules for dropdown", uniqueModules);
    } catch (error) {
      setError("Failed to fetch user access for modules.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (selectedGroup) {
      fetchUserAccessForModules(selectedGroup);
    }
  }, [selectedGroup]);

  useEffect(() => {
    if (selectedGroup && selectedModule) {
      fetchMapReports(selectedGroup);
    }
  }, [selectedGroup, selectedModule]);

  const handleSelectallChange = (reportId) => {
    const newCheckedReports = checkedReports.includes(reportId)
      ? checkedReports.filter((id) => id !== reportId)
      : [...checkedReports, reportId];

    setCheckedReports(newCheckedReports);
    setSelectAllChecked(newCheckedReports.length === reports.length); // Update Select All based on checked count
  };

  // Handle Select All checkbox change
  const handleSelectAllChange = () => {
    if (selectAllChecked) {
      setCheckedReports([]);
    } else {
      setCheckedReports(reports.map((report) => report.REPORTID));
    }
    setSelectAllChecked(!selectAllChecked);
  };

  return (
    <>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs2}
                // position="fixed"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none">Home</Link>
                <Link underline="none">Reports</Link>
                <Link underline="none">Map Reports</Link>
              </Breadcrumbs>
            </Grid>
          </Grid>
        </Box>
      </AppBar>

      <Box sx={styles.box_container_add}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box sx={styles.col_title}>
              <Typography variant="title" align="left">
                Map Reports
              </Typography>
            </Box>
          </Grid>

          {/* Form Section */}
          <Grid item xs={12} sm={12} md={5} lg={5} xl={5}>
            <Box
              // p={2}
              sx={{
                ...styles.col_1,
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
                justifyContent: "flex-start",
                textAlign: "left",
                p: 2,

                marginLeft: 0,
                maxHeight: "68vh",
                height: {
                  xs: "auto",
                  sm: "auto",
                  md: "100vh",
                  lg: "100vh",
                  xl: "100vh",
                },

                // boxShadow: `0px 0px 4px 0px ${theme.palette.input_field.stroke}`,
                boxShadow: 1,
                borderRadius: 1,
                background: theme.palette.background.paper,

                borderRight: theme.palette.divider,
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <Box sx={styles.tg_col_title}>
                    <Typography
                      variant="m_sub_title"
                      sx={{
                        color: theme.palette.text.primary,
                      }}
                    >
                      Map User Group Reports
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} mt={2}>
                  <FormControl fullWidth size="small">
                    <InputLabel id="group-select-label">User Group</InputLabel>
                    <Select
                      labelId="group-select-label"
                      id="group-select"
                      label="User Group"
                      value={selectedGroup}
                      onChange={handleGroupChange}
                    >
                      {userGroups.map((group) => (
                        <MenuItem key={group.GROUPCODE} value={group.GROUPCODE}>
                          {group.GROUPNAME}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <Box mt={2} width={"100%"}>
                    <FormControl fullWidth size="small">
                      <InputLabel id="group-select-label">Modules</InputLabel>
                      <Select
                        labelId="group-select-label"
                        id="group-select"
                        label="User Group"
                        value={selectedModule}
                        onChange={handleModuleChange}
                      >
                        {modules.map((module) => (
                          <MenuItem
                            key={module.MODULECODE}
                            value={module.MODULECODE}
                          >
                            {module.MODULENAME}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                </Grid>

                <Grid
                  item
                  xs={12}
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "flex-end",
                  }}
                >
                  <Box
                    sx={{
                      width: "20%",
                    }}
                  >
                    <Button
                      sx={styles.btn_primary}
                      size="medium"
                      variant="contained"
                      onClick={handleMapReport}
                    >
                      Confirm
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Grid>

          <Grid item xs={12} sm={12} md={7} lg={7} xl={7}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                // alignItems: "flex-end",
                justifyContent: "flex-start",
                // textAlign: "left",
                padding: 2,
                // marginLeft: 0,
                width: "100%",
                height: "68vh",
                borderRadius: 1,
                boxShadow: 1,
                background: theme.palette.background.paper,
                borderRight: theme.palette.divider,
              }}
            >
              {/* <Box sx={styles.tg_col_title}> */}
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems={"center"}
                width="100%"
                sx={styles.tg_col_title}
              >
                {/* <Box display="flex"> */}
                <Typography
                  variant="m_sub_title"
                  sx={{
                    color: theme.palette.text.primary,
                    textAlign: "left",
                    // padding: 1,
                  }}
                >
                  Reports
                </Typography>
                {/* </Box> */}
                <Box display="flex" alignItems="center">
                  <Typography variant="body1" mr={1}>
                    Select All
                  </Typography>
                  <Checkbox
                    checked={selectAllChecked}
                    onChange={handleSelectAllChange}
                    sx={{ padding: 0 }}
                  />
                </Box>
              </Box>
              {/* </Box> */}

              <Box
                sx={{
                  // ...styles.st_page_table,
                  // height: "55vh",
                  overflowY: "auto", // Enable scrolling
                  width: "100%",
                  mt: 2,
                  p: 2,
                }}
              >
                {/* <Typography variant="h6" gutterBottom>
                Reports
              </Typography> */}
                {reports.map((report) => (
                  <Box
                    key={report.REPORTID}
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    p={1}
                    sx={{
                      borderBottom: `1px solid ${theme.palette.divider}`,
                    }}
                  >
                    <Typography variant="body1">{report.REPORTNAME}</Typography>

                    <Checkbox
                      checked={checkedReports.includes(report.REPORTID)}
                      onChange={() => handleCheckboxChange(report.REPORTID)}
                    />
                  </Box>
                ))}
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <SnackbarMessage
        open={snackbarOpen}
        handleClose={handleSnackbarClose}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </>
  );
}

export default MapReports;
